import { render, staticRenderFns } from "./GlobalSearch.vue?vue&type=template&id=3795af09"
import script from "./GlobalSearch.vue?vue&type=script&lang=js"
export * from "./GlobalSearch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2326903440/src/bitbucket.org/Modis-ito/frontend-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3795af09')) {
      api.createRecord('3795af09', component.options)
    } else {
      api.reload('3795af09', component.options)
    }
    module.hot.accept("./GlobalSearch.vue?vue&type=template&id=3795af09", function () {
      api.rerender('3795af09', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/drc/components/globalSearch/GlobalSearch.vue"
export default component.exports